import React, { useState } from "react";
import {
  FaqData,
  FaqData2,
  HomepageFaqData,
  HomepageFaqData2,
} from "./Faq.data";
import DownVector from "../../images/Svg/DownVector.svg";
import ArrowIcon from "../../images/Svg/ArrowIcon.svg";
import FaqComponents from "../../components/Faq/Faq.components";
import JoinCommunity from "../../components/JoinCommunity/JoinCommunity.component";
import { Fade } from "react-reveal";
import { Helmet } from "react-helmet";
import { analytics } from "../../utils/firebase";
import { logEvent } from "firebase/analytics";

const Faq = ({ title, t1, t2 }) => {
  const [isOpen, setIsOpen] = useState(null);
  const toggle = (value) => {
    setIsOpen(isOpen === value ? null : value);
  };
  const pn = window.location.pathname;
  let description = "";
  if (title === "Join Our Conversations") {
    description =
      "Have any questions? Queries? Join our discord server to let us know";
  } else {
    description = "For more queries, join our discord server and let us know!";
  }
  let text;
  let metaDes;
  if (pn === "/faqs") {
    text = "Setu Frequently Asked Questions";
    metaDes = "Setu Frequently Asked Questions";
  } else {
    text = "Expand Your Brand In Web 3.0 For Free And Earn More - Setu";
    metaDes =
      "Bridge the gap between Web 2.0 and Web 3.0 with Setu. Move your content to decentralised social media. Earn more, own your content, and expand your brand.";
  }

  const handleClick = () => {
    logEvent(analytics, "SEE_MORE_QUESTIONS_HOMEPAGE_CLICKED");
    window.location.href = "/faqs";
  };
  return (
    <Fade cascade duration={1000}>
      <Helmet>
        <title>{text}</title>
        <meta name="description" content="Setu Frequently Asked Questions" />
      </Helmet>
      <section className="py-12 container mx-auto px-[24px] sm:px-[24px] md:px-0 lg:px-6 ">
        <div className="text-center">
          <h2 className="Secondheading font-bold">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="flex flex-wrap justify-end mt-12">
          <div className="mx-auto w-[98%] sm:w-[98%] max-w-[1000px] sm:max-w-[1000px] xl:max-w-[558px]  xl:w-[558px]">
            {/* testing */}
            {t1.map((data, index) => (
              <FaqComponents
                key={index}
                data={data}
                toggle={toggle}
                isOpen={isOpen}
              />
            ))}
          </div>
          <div className="mx-auto w-[98%] sm:w-[98%] max-w-[1000px] sm:max-w-[1000px] xl:max-w-[558px]  xl:w-[558px]">
            {t2.map((data, index) => (
              <FaqComponents
                key={index}
                data={data}
                toggle={toggle}
                isOpen={isOpen}
              />
            ))}
          </div>
        </div>

        {pn == "/" && (
          <div className="mt-[24px] flex justify-center ">
            <div onClick={handleClick}>
              <button className="bg-[#FFFFFF]  text-black w-[276px] flex justify-around py-[16px] px-[24px] border border-[#E1E1E1] rounded-[8px] items-center hover:shadow-md">
                See More Questions
                <span className="pl-2">
                  <img src={ArrowIcon} alt="" />
                </span>
              </button>
            </div>
          </div>
        )}
        {pn !== "/" && (
          <div className="mt-[110px]">
            <JoinCommunity
              title={title}
              description={description}
              name="JOIN_DISCORD_CLICKED_FROM_FAQ"
            />
          </div>
        )}
      </section>
    </Fade>
  );
};

export default Faq;
